import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';
import { IxcFeesV1FeeType } from '@interxfi/types';

const pathParamsSchema = z.object({
  feeType: z.enum(IxcFeesV1FeeType),
});

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/$feeType/_$feeType',
)({
  params: {
    parse: (values) => {
      const parsed = pathParamsSchema.safeParse(values);
      if (!parsed.success) {
        return { feeType: IxcFeesV1FeeType.Unspecified } as const;
      }

      return parsed.data;
    },
  },
});
